module.exports = __webpack_public_path__ + "static/img/banner.a4af6f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/banner.jpg
// module id = veyg
// module chunks = 9